
export type EmptyCallback = () => void;
export type ActionCallback<T> = (a: T) => void;
export type FuncCallback<T, R> = (a: T) => R;
export type ActionCallback2<T1, T2> = (a1: T1, a2: T2) => void;
export type ActionCallback3<T1, T2, T3> = (a1: T1, a2: T2, a3: T3) => void;
export type RenewTokenCallback = () => Promise<boolean>;
export type Func<T> = () => T;

export type ApiCallback = (r: ApiErr) => void;
export type TApiCallback<T> = (r: TApiOut<T>) => void;

export enum InvalidUser {
	Expired,
	Inactive
}
export interface ApiErr {
	error: string;
	inv?: InvalidUser;
}
export interface ApiOut extends ApiErr {

	//rid: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	d: any;
}
export interface TApiOut<T> extends ApiErr {

	//rid: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	d: T;
}
interface ApiIn {
	sid: string;
	hid: string;
	at: AuthType;
	/*rid: number;*/
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	d: any;
}
export enum UserRoles {
	Regular,
	ManageData = 4,
	Agreed = 16,
	Unverified = 64,
	Partner = 256,
	Admin = ManageData | Agreed
}
export interface AuthOut {
	sid: string;
	uid: number;
	tls: UserRoles;
	domain: string;
}

export enum AuthType {
	Email,
	Google,
	Microsoft,
	Facebook,
	Twitter,
	Apple
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
//export type FetchDataCallback = (r: ApiOut, o: any) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export class IApiAuthState {
	b: string;
	bt: AuthType;
}
export class ApiState {
	/*static expiredError: string = 'expired';*/
	static noSessionError: string = 'no session';
	static invalidTokenError: string = 'invalid_token';
	static expiredTokenError: string = 'expired_token';
	static contentTypeJson = 'application/json';
	static emailAuthToken = 'mt';
	sessionId: string;
	hubId: string;
	userId: number;
	url: string;
	//requests = new Map();
	//id = 0;
	onSessionExpired: EmptyCallback;
	onUserExpired: ActionCallback<InvalidUser>;
	//expired: boolean;
	inv: InvalidUser;
	bearer: string = ApiState.emailAuthToken;
	bearerType: AuthType = AuthType.Email;
	get isUserPaused() {
		return this.inv != null;
	}
	setAuth(url: string, sessionId: string = null, userId: number = null, onSessionExpired: EmptyCallback = null) {
		this.url = url;
		if (onSessionExpired)
			this.onSessionExpired = onSessionExpired;
		this.sessionId = sessionId;
		this.userId = userId;
		this.inv = null;
		//this.expired = false;
		this.hubId = null;
	}

	validateSession(d: ApiErr) {
		if (d == null || d.error == null || !this.onSessionExpired)
			return;
		if (d.error == ApiState.noSessionError
			/*|| d.error == ApiState.expiredError*/
			|| d.error == ApiState.invalidTokenError) {
			//this.expired = true;
			this.onSessionExpired();
		}
	}
}

export class apiBase {

	private static st = new ApiState();

	static renewTokenHandler: RenewTokenCallback;
	public static get authState(): IApiAuthState {
		return {
			b: apiBase.st.bearer,
			bt: apiBase.st.bearerType,
		}
	}
	public static set authState(state: IApiAuthState) {
		apiBase.st.bearer = state?.b;
		apiBase.st.bearerType = state?.bt;
		if (apiBase.st.bearerType == null) {
			apiBase.st.bearerType = AuthType.Email;
			apiBase.st.bearer = ApiState.emailAuthToken;
		}
	}

	public static get state() {
		return apiBase.st;
	}
	public static setAuthUrl(url: string) {
		apiBase.state.setAuth(url);
	}
	public static setAuth(url: string, sessionId: string, userId: number, onSessionExpired: EmptyCallback) {
		apiBase.state.setAuth(url, sessionId, userId, onSessionExpired);
	}
	protected static async postData<T>(method: string, callback: TApiCallback<T>, args: any = null, host: string = null, validSession = true) {
		let callurl = apiBase.st.url + method;
		if (host)
			callurl = `https://${host}/${method}`;
		try {
			for (let i = 0; i < 2; i++) {
				const res = await fetch(callurl, {
					method: 'POST',
					headers: {
						'Accept': ApiState.contentTypeJson,
						'Content-Type': ApiState.contentTypeJson,
						'Authorization': `Bearer ${apiBase.st.bearerType.toString()}${apiBase.st.bearer}`
					},
					body: JSON.stringify(apiBase.getFetchInput(args))
				});
				if (res.ok) {
					const obj = await res.json() as TApiOut<T>;
					if (validSession && apiBase.renewTokenHandler && obj.error == ApiState.expiredTokenError) {
						if (i == 0)
							if (await apiBase.renewTokenHandler())
								continue;
						obj.error = ApiState.noSessionError;
					}

					if ((obj?.inv != null) && (apiBase.state.inv == null)) {
						apiBase.state.inv = obj.inv;
						if (apiBase.state.onUserExpired)
							apiBase.state.onUserExpired(apiBase.state.inv);
					}

					callback(obj);

					if (validSession)
						apiBase.state.validateSession(obj);

				} else {
					if (res.bodyUsed)
						callback({ error: 'HTTP error: ' + res.status + ' ' + await res.text(), d: null });
					else
						callback({ error: 'HTTP error: ' + res.status, d: null });
				}
				return;
			}
		} catch (e) {
			callback({ error: 'error: ' + e, d: null });
		}
	}

	public static getFetchInput(args: any): ApiIn {
		return {
			sid: apiBase.st.sessionId,
			hid: apiBase.st.hubId,
			at: apiBase.st.bearerType,
			d: args
		}
	}
}
